__turbopack_context__.v({
  "mainContent": "BloodTestSection-module__5Qb2Iq__mainContent",
  "root": "BloodTestSection-module__5Qb2Iq__root",
  "tab": "BloodTestSection-module__5Qb2Iq__tab",
  "tabs": "BloodTestSection-module__5Qb2Iq__tabs",
  "testCards": "BloodTestSection-module__5Qb2Iq__testCards",
});
